import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyLocationKey,
  ShopifyReverseDeliveryLineItemKey,
  ShopifyReverseFulfillmentOrderDispositionKey,
  ShopifyReverseFulfillmentOrderDispositionToLocationKey,
  ShopifyReverseFulfillmentOrderDispositionToReverseDeliveryLineItemKey,
  ShopifyReverseFulfillmentOrderDispositionToReverseFulfillmentOrderLineItemKey,
  ShopifyReverseFulfillmentOrderDispositionToShopKey,
  ShopifyReverseFulfillmentOrderLineItemKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyReverseFulfillmentOrderDispositionKey,
  "2024-07": {
    name: "Shopify Reverse Fulfillment Order Disposition",
    graphQLTypename: "ReverseFulfillmentOrderDisposition",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "id" } },
      },
      {
        name: "Quantity",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "quantity" } },
      },
      {
        name: "Type",
        fieldType: FieldType.Enum,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "type", isShopifyEnum: true } },
        configuration: {
          allowMultiple: false,
          allowOther: true,
          options: [{ name: "MISSING" }, { name: "NOT_RESTOCKED" }, { name: "PROCESSING_REQUIRED" }, { name: "RESTOCKED" }],
        },
      },
      {
        name: "Location",
        fieldType: FieldType.BelongsTo,
        key: ShopifyReverseFulfillmentOrderDispositionToLocationKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "location_id",
            graphQLFieldKey: "locationId",
            graphQLSelection: `
            location {
              id
            }
            `,
          },
        },
        configuration: {
          relatedModelKey: ShopifyLocationKey,
        },
      },
      {
        name: "Reverse Fulfillment Order Line Item",
        fieldType: FieldType.BelongsTo,
        key: ShopifyReverseFulfillmentOrderDispositionToReverseFulfillmentOrderLineItemKey,
        configuration: {
          relatedModelKey: ShopifyReverseFulfillmentOrderLineItemKey,
        },
      },
      {
        name: "Reverse Delivery Line Item",
        fieldType: FieldType.BelongsTo,
        key: ShopifyReverseFulfillmentOrderDispositionToReverseDeliveryLineItemKey,
        configuration: {
          relatedModelKey: ShopifyReverseDeliveryLineItemKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyReverseFulfillmentOrderDispositionToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: {
      type: "inherit",
    },
  },
};

export const ShopifyReverseFulfillmentOrderDisposition = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
